<script setup>
import { computed } from 'vue';
import { useQuery } from 'villus';
import { useStore } from '@/store/Store.js';
import BlogFeaturedList from '@/components/blog-cta/BlogFeaturedList.vue';

const props = defineProps({
    data: { type: Object, default: () => {} },
    color: { type: String, default: '' },
    mainColor: {
        type: String,
        default: '',
    },
});

const store = useStore();
const variables = computed(() => ({ lang: store.lang.value, sections: props.data.data.typesDeContenus ?? ['blog', 'recette'] }));

let posts = props.data.data.selectedPosts;

if (!props.data.data || !props.data.data.selectedPosts || props.data.data.selectedPosts.length == 0) {
    const { data: queryData } = await useQuery({
        variables,
        query: `
        query FetchFeaturedPosts($lang: [String], $sections: [String]) {
            selectedPosts: entries (section: $sections, orderBy: "postDate DESC", limit: 4, site: $lang) {
                id,
                title,
                uri,
                ... on blog_Entry {
                    day: postDate @formatDateTime (format: "d"),
                    month: postDate @formatDateTime (format: "n"),
                    year: postDate @formatDateTime (format: "Y"),
                    category: blogCategory { title },
                    cover: blogCover { title, url @transform (format: "webp", quality: 80, width: 800, height: 426, immediately: true) },
                }
                ... on recette_Entry {
                    category: recetteCategory { title },
                    cover: recetteCover { title, url @transform (format: "webp", quality: 80, width: 800, height: 426, immediately: true) },
                }
            }
        }`,
    });

    posts = queryData.value.selectedPosts;
}
</script>

<template>
    <div class="FeaturedPosts">
        <BlogFeaturedList
            :title-top="data.data.featuredContentTitle"
            :cta="data.data.featuredContentLinkText"
            :cta-link="data.data.featuredContentLink"
            :cta-target="data.data.featuredContentLinkNewTab ? '_blank' : ''"
            :color="'dark-' + mainColor"
            :blogs="posts"
            ga-label="ctaBlocArticlesEnVedette"
            :wysiwyg-data="data.data.featuredContentText"
        />
    </div>
</template>
